<template>
  <div>
    <layout-header></layout-header>
    <layout-body class="mt-4"></layout-body>
    <layout-footer></layout-footer>
  </div>
</template>
<script>
import LayoutHeader from './components/layout/Header.vue';
import LayoutFooter from './components/layout/Footer.vue';
import LayoutBody from './components/layout/Body.vue';

export default {
  components: {
    LayoutHeader,
    LayoutFooter,
    LayoutBody
  }
};
</script>
